import { reactive } from 'vue'

const store = reactive({
  user: {
    token: localStorage.getItem('user_token') || null,
    info: JSON.parse(localStorage.getItem('user_info')) || null
  },
  cart: [],
  theme: 'light',
  isAuthModalOpen: false,

  // Methods
  login(token, userInfo) {
    this.user.token = token
    this.user.info = userInfo
    localStorage.setItem('user_token', token)
    localStorage.setItem('user_info', JSON.stringify(userInfo))
  },

  logout() {
    this.user.token = null
    this.user.info = null
    localStorage.removeItem('user_token')
    localStorage.removeItem('user_info')
  },

  addToCart(item) {
    this.cart.push(item)
    // Persist if needed
  }
})

export default store
